import { useNavigate } from 'react-router-dom'
import ErrorDisclaimer from '../../Common/ErrorDisclaimer/ErrorDisclaimer'
import { patientPageErrors } from '../_errors'

export const PatientErrorDisclaimer = () => {
    const navigate = useNavigate()

    return (
        <ErrorDisclaimer
            label={patientPageErrors.unknownError}
            cancelButton={{
                label: 'Retour à la liste',
                action: () => navigate('/patients'),
            }}
            reloadButton={{
                label: 'Recharger la fiche patient',
            }}
        />
    )
}
